import { render, staticRenderFns } from "./ProgramDashboardManager.vue?vue&type=template&id=d9a546b0&scoped=true"
import script from "./ProgramDashboardManager.vue?vue&type=script&lang=js"
export * from "./ProgramDashboardManager.vue?vue&type=script&lang=js"
import style0 from "./ProgramDashboardManager.vue?vue&type=style&index=0&id=d9a546b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a546b0",
  null
  
)

export default component.exports